import { useCallback } from 'react';

import { IconButton, IconButtonProps } from '@mui/material';
import { CloseIcon, MenuIcon } from 'icons';
import { appDrawerHide, appDrawerShow, appToggleMobileMenu, selectMobileMenuOpen } from 'modules/app/state';
import { useAppDispatch, useAppSelector } from 'store';

interface MenuButtonProps extends IconButtonProps {
  open: boolean;
}

const MenuButton = ({ open, onClick, ...props }: MenuButtonProps) => (
  <IconButton
    sx={{ width: 32, height: 32 }}
    color="inherit"
    aria-label="Main menu"
    onClick={onClick}
    data-testid="menu-button"
    disableRipple
    {...props}
  >
    {open ? <CloseIcon fontSize="large" /> : <MenuIcon fontSize="large" />}
  </IconButton>
);

export const MobileMenuButton = () => {
  const isMobileMenuOpen = useAppSelector(selectMobileMenuOpen);
  const dispatch = useAppDispatch();

  const handleNavigationToggle = useCallback(() => {
    dispatch(appToggleMobileMenu());
    if (isMobileMenuOpen) {
      dispatch(appDrawerHide());
    } else {
      dispatch(appDrawerShow());
    }
  }, [dispatch, isMobileMenuOpen]);

  return <MenuButton open={isMobileMenuOpen} onClick={handleNavigationToggle} />;
};
